<template>
  <div>
      <div class="intro-y flex items-center mt-8">
          <h2 class="text-lg font-medium mr-auto">Makeable Transfer</h2>
      </div>
      <div class="grid grid-cols-12 mt-5">
          <div class="intro-y col-span-12 lg:col-span-12">
              <!-- BEGIN: Input -->
              <div class="intro-y box">
                  <div class="p-5">
                      <div class="grid grid-cols-12 gap-x-5">
                          <div class="col-span-12 xl:col-span-4">

                              <div>
                                  <label for="update-profile-form-8" class="form-label">Scan Lot No</label>
                                  <div class="input-group mt-2">

                                      <input id="update-profile-form-6" type="text" tabindex="1" placeholder="Scan Barcode" v-model="scan_lot_no" :class="{'form-control':true,'loading':scanload}" :disabled="scanload" autocomplete="off" @change="scanAndAddPack" />

                                      <button type="button" class="btn btn-primary mr-auto" @click="scanAndAddPack" style="border-radius: 0!important">
                                          <SearchIcon class="w-5 h-5 mr-2" /> Search
                                      </button>
                                      <button type="button" class="btn btn-primary-outline mr-auto" @click="clearSearch('')" style="border-radius: 0!important">
                                          Clear
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- END: Input -->
          </div>
      </div>

      <div class="grid grid-cols-12 mt-5">
          <div class="intro-y col-span-12 lg:col-span-12">
              <!-- BEGIN: Input -->
              <div class="intro-y box">
                  <div class="flex flex-col sm:flex-row items-center justify-between p-5 border-b border-gray-200 dark:border-dark-5">
                      <h2 class="font-medium text-base mr-auto">Packet Details</h2>
                      <div class="text-right">
                          <button @click="setPrintAllData(stock_items)" class="btn btn-primary btn-sm mr-2">Print All</button>
                          <button class="btn btn-danger btn-sm mr-2"  v-if="user_details.user_role == 1 && packet_details.type == 'makeable'" @click="resetMakeable">Reset Makeable</button>
                          <button class="btn btn-primary btn-sm mr-2"  v-if="user_details.user_role == 1 && packet_details.type == 'makeable'" @click="editMakeable">Edit Makeable</button>
                          <!-- <button class="btn btn-primary btn-sm mr-2" @click="set_part_details" v-if="packet_details.part_ready == 1 && (user_details.account_id == packet_details.manager_id) && (user_details.user_role == packet_details.manager_type)">Add Planning Part</button> -->
                          <!-- <button class="btn btn-primary btn-sm mr-2" @click="reset_ls_data" v-if="packet_details.part_ready == 1 && (user_details.account_id == packet_details.manager_id) && (user_details.user_role == packet_details.manager_type)">Reset(LS)</button> -->
                          <!-- <button class="btn btn-primary btn-sm mr-2" @click="get_ls_edit_details" v-if="packet_details.part_ready == 1 && (user_details.account_id == packet_details.manager_id) && (user_details.user_role == packet_details.manager_type)">Edit(LS)</button> -->
                      </div>
                  </div>

                  <div class="p-1 pb-10">
                      <div class="col-span-12">
                              <div style="background-color:#fff;">
                                  <table class="mt-3 w-full">
                                      <thead>
                                          <tr class="border-b bg-gray-200 border dark:bg-dark-1">
                                              <th class="py-2 text-center border">Pkt No</th>
                                              <th class="py-2 text-center border">Weight</th>
                                              <th class="py-2 text-center border">Current Weight</th>
                                              <th class="py-2 text-center border">MK Weight</th>
                                              <th class="py-2 text-center border">Exp. Wt</th>
                                              <th class="py-2 text-center border">Sp</th>
                                              <th class="py-2 text-center border">Cl</th>
                                              <th class="py-2 text-center border">Prt</th>
                                              <th class="py-2 text-center border">Ct</th>
                                              <th class="py-2 text-center border">Pl</th>
                                              <th class="py-2 text-center border">Sym</th>
                                              <th class="py-2 text-center border">Stn</th>
                                              <th class="py-2 text-center border">Fluc</th>
                                              <th class="py-2 text-center border">Tn</th>
                                              <th class="py-2 text-center border w-28">Print</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for="(packet, index) in stock_items" :key="index" class="border hover:bg-gray-200 p-0 cursor-pointer">
                                              <td class="py-1 font-medium text-center border">{{ packet.number }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.weight }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.cr_weight }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.mk_weight }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.polish_weight }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.shape }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.color }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.purity }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.cut }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.polish }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.symmetry }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.stone }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.fluerocent }}</td>
                                              <td class="py-1 font-medium text-center border">{{ packet.tension }}</td>
                                              <td class="py-1 font-medium text-center border">
                                                  <div class="flex justify-between items-center">
                                                    <input
                                                  class="show-code form-check-switch mr-0 ml-3 p-0"
                                                  type="checkbox" v-model="packet.print_status"
                                                />
                                                      <button class="btn btn-primary btn-sm p-1 mr-3" v-if="packet.print_status == true" @click="setPrintData(packet)">
                                                          <PrinterIcon class="w-5 h-5" />
                                                      </button>
                                                      <button class="btn btn-primary btn-sm p-1 mr-3" v-if="packet.print_status == false" disabled @click="setPrintData(packet)">
                                                          <PrinterIcon class="w-5 h-5" />
                                                      </button>
                                                  </div>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                      </div>
                  </div>
              </div>
              <!-- END: Input -->
          </div>
      </div>
      <div class="grid grid-cols-12 mt-5" v-if="edit_flag == 1 && (packet_details.status == 1) && (user_details.account_id == packet_details.manager_id) && (user_details.user_role == packet_details.manager_type)">
          <div class="intro-y col-span-12 lg:col-span-12">
              <!-- BEGIN: Input -->
              <div class="intro-y box p-5 px-1">

                <div class="flex flex-col sm:flex-row items-center p-5 py-3 border-b border-gray-200 dark:border-dark-5">
                      <h2 class="font-medium text-base mr-auto">Makeable Transfer Details</h2>
                  </div>

                  <div class="p-5">
                      <div class="grid grid-cols-12 gap-x-5 w-full">
                          <div class="col-span-12 md:col-span-4">

                              <div>
                                  <label for="update-profile-form-6" class="form-label">Packet No :&nbsp; </label>
                                  <label for="update-profile-form-6 " class="form-label font-bold"> {{ packet_details.number + ' / ' + packet_details.vepari_no}} </label>
                              </div>
                              <div>
                                  <label for="update-profile-form-6" class="form-label">Lot weight :&nbsp; </label>
                                  <label for="update-profile-form-6 " class="form-label font-bold"> {{ packet_details.cr_weight}} Ct</label>
                              </div>

                              <!-- <div>
                                  <label for="update-profile-form-6" class="form-label">Current Manager :&nbsp; </label>
                                  <label for="update-profile-form-6 " class="form-label font-bold"> {{ packet_details.employee_first_name + ' '+ packet_details.employee_last_name}}</label>
                              </div>
                              <div>
                                  <label for="update-profile-form-6" class="form-label">Issue At :&nbsp; </label>
                                  <label for="update-profile-form-6 " class="form-label font-bold"> {{ packet_details.created_at}}</label>
                              </div> -->
                          </div>
                          <div class="col-span-12 md:col-span-2"></div>
                      </div>
                  </div>

                  <div class="p-1 pb-10">
                      <div class="col-span-12">
                          <div class="border rounded mx-5">
                              <div class="w-full max-w-full overflow-x-auto relative">
                                  <table class="min-w-[100px] w-full border border-gray-200 text-sm">
                                      <thead class="bg-slate-100 sticky top-0 z-10">
                                        <tr class="bg-slate-50 text-xs">
                                          <th class="th">#</th>
                                          <th class="th">PL Wt</th>

                                          <th class="th">Shp</th>
                                          <th class="th">Color</th>
                                          <th class="th">Purity</th>
                                          <th class="th">Cut</th>
                                          <th class="th">Polish</th>
                                          <th class="th">Symm</th>
                                          <th class="th">Fluc</th>
                                          <th class="th">Tension</th>

                                          <th class="th">Ratio</th>
                                          <th class="th">Table</th>
                                          <th class="th">Length</th>
                                          <th class="th">Width</th>
                                          <th class="th">Height</th>
                                          <th class="th">Girdle %</th>

                                          <th class="th">R Rate</th>
                                          <th class="th">Back %</th>
                                          <th class="th">Per/Ct $</th>
                                          <th class="th">Total $</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for="(plan,index) in plan_details" :key="index">
                                              <td class="py-1 border-b text-xs lg:text-md text-center border-r"><span><input type="checkbox" v-model="plan.ls_check" @change="validateLSCheck(plan)"></span></td>
                                              <!-- <td class="td"><input v-model="plan.weight" type="text" @keypress="$h.preventInvalidInput" class="input"
                                                  @change="onPlanValueChange(plan, 'weight')" /></td> -->
                                              <td class="td"><input v-model="plan.polish_weight" type="text" @keypress="$h.preventInvalidInput" class="input-50px"
                                                  @change="onPlanValueChange(plan, 'polish_weight')" /></td>

                                              <td class="td"><select v-model="plan.shape" class="select"  :title="getShapeName(plan.shape)"  @change="onPlanValueChange(plan, 'shape')">
                                                  <option v-for="(s, i) in diamond.shapes" :key="i" :value="s.id">{{ s.shape_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.color" class="select-60px"  @change="onPlanValueChange(plan, 'color')">
                                                  <option v-for="(c, i) in diamond.colors" :key="i" :value="c.id">{{ c.color_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.purity" class="select-70px"  @change="onPlanValueChange(plan, 'purity')">
                                                  <option v-for="(p, i) in diamond.purities" :key="i" :value="p.id">{{ p.purity_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.cut" class="select-60px">
                                                  <option v-for="(c, i) in diamond.cuts" :key="i" :value="c.id">{{ c.cut_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.polish" class="select-60px">
                                                  <option v-for="(p, i) in diamond.polish" :key="i" :value="p.id">{{ p.polish_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.symmetry" class="select-60px">
                                                  <option v-for="(s, i) in diamond.symmetry" :key="i" :value="s.id">{{ s.symmetry_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.fluerocent" class="select-60px">
                                                  <option v-for="(s, i) in diamond.fluerocents" :key="i" :value="s.id">{{ s.fluerocent_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.tension" class="select-60px">
                                                  <option v-for="(s, i) in diamond.tensions" :key="i" :value="s.id">{{ s.tension_name }}</option>
                                                </select></td>

                                              <td class="td"><select v-model="plan.ratio" class="select-60px">
                                                  <option v-for="(r, i) in diamond.ratios" :key="i" :value="r.id">{{ r.ratio_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.tabl" class="select-60px">
                                                  <option v-for="(t, i) in diamond.tabls" :key="i" :value="t.id">{{ t.tabl_name }}</option>
                                                </select></td>
                                                <td class="td"><select v-model="plan.lengths" class="select-60px">
                                                  <option v-for="(len, i) in diamond.lengths" :key="i" :value="len.id">{{ len.length_name }}</option>
                                                </select></td>
                                                <td class="td"><select v-model="plan.width" class="select-60px">
                                                  <option v-for="(wd, i) in diamond.width" :key="i" :value="wd.id">{{ wd.width_name }}</option>
                                                </select></td>
                                                <td class="td"><select v-model="plan.height" class="select-60px">
                                                  <option v-for="(h, i) in diamond.heights" :key="i" :value="h.id">{{ h.height_name }}</option>
                                                </select></td>
                                                <td class="td"><input v-model="plan.girdleper" class="input-50px" @keypress="$h.preventInvalidInput"/></td>

                                              <td class="td"><input v-model="plan.r_rate" disabled class="input-80px bg-gray-100" /></td>
                                              <td class="td"><input v-model="plan.discount" class="input-50px"
                                                  @change="onPlanValueChange(plan, 'discount')" @keypress="$h.preventInvalidInput"/></td>
                                              <td class="td"><input v-model="plan.value" class="input-70px"
                                                  @change="onPlanValueChange(plan, 'value')" @keypress="$h.preventInvalidInput"/></td>
                                              <td class="td"><input v-model="plan.total_value" disabled class="input-70px bg-gray-100" /></td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                              <div class="w-full flex justify-between py-5">
                                <div>

                                  <button class="btn btn-primary btn-sm py-1" title="Add New Rough" @click="addNewPart">
                                    <PlusIcon class="h-4 w-4" /> Add Plan
                                  </button>
                                </div>
                                <div>

                                  <button type="button" class="btn btn-primary btn-sm" @click="submitReturnRough">
                                      Transfer makeable
                                  </button>
                                </div>

                              </div>

                          </div>

                      </div>
                  </div>
              </div>
              <!-- END: Input -->
          </div>
      </div>
      <div class="grid grid-cols-12 mt-5" v-if="edit_flag == 2 && (user_details.user_role == 1)">
          <div class="intro-y col-span-12 lg:col-span-12">
              <!-- BEGIN: Input -->
              <div class="intro-y box p-5 px-1">

                <div class="flex flex-col sm:flex-row items-center p-5 py-3 border-b border-gray-200 dark:border-dark-5">
                      <h2 class="font-medium text-base mr-auto">Makeable Transfer Details</h2>
                  </div>

                  <div class="p-5">
                      <div class="grid grid-cols-12 gap-x-5 w-full">
                          <div class="col-span-12 md:col-span-4">

                              <div>
                                  <label for="update-profile-form-6" class="form-label">Packet No :&nbsp; </label>
                                  <label for="update-profile-form-6 " class="form-label font-bold"> {{ packet_details.number + ' / ' + packet_details.vepari_no}}</label>
                              </div>
                              <div>
                                  <label for="update-profile-form-6" class="form-label">Lot weight :&nbsp; </label>
                                  <label for="update-profile-form-6 " class="form-label font-bold"> {{ packet_details.cr_weight}} Ct</label>
                              </div>

                              <!-- <div>
                                  <label for="update-profile-form-6" class="form-label">Current Manager :&nbsp; </label>
                                  <label for="update-profile-form-6 " class="form-label font-bold"> {{ packet_details.employee_first_name + ' '+ packet_details.employee_last_name}}</label>
                              </div>
                              <div>
                                  <label for="update-profile-form-6" class="form-label">Issue At :&nbsp; </label>
                                  <label for="update-profile-form-6 " class="form-label font-bold"> {{ packet_details.created_at}}</label>
                              </div> -->
                          </div>
                          <div class="col-span-12 md:col-span-2"></div>
                      </div>
                  </div>

                  <div class="p-1 pb-10">
                      <div class="col-span-12">
                          <div class="border rounded mx-5">
                              <div class="w-full max-w-full overflow-x-auto relative">
                                  <table class="min-w-[1600px] w-full border border-gray-200 text-sm">
                                      <thead class="bg-slate-100 sticky top-0 z-10">
                                        <tr class="text-center">
                                          <th rowspan="2" class="th">#</th>

                                          <th colspan="1" class="th-group">Weight</th>
                                          <th colspan="8" class="th-group">Quality</th>
                                          <th colspan="3" class="th-group">Property</th>
                                          <th colspan="4" class="th-group">Pricing</th>
                                        </tr>

                                        <tr class="bg-slate-50 text-xs">
                                          <th class="th">PL Wt</th>

                                          <th class="th">Shp</th>
                                          <th class="th">Color</th>
                                          <th class="th">Purity</th>
                                          <th class="th">Cut</th>
                                          <th class="th">Polish</th>
                                          <th class="th">Symm</th>
                                          <th class="th">Fluc</th>
                                          <th class="th">Tension</th>

                                          <th class="th">Ratio</th>
                                          <th class="th">Table</th>
                                          <th class="th">Height</th>

                                          <th class="th">R Rate</th>
                                          <th class="th">Back %</th>
                                          <th class="th">Per/Ct $</th>
                                          <th class="th">Total $</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for="(plan,index) in edit_plan_details" :key="index">
                                              <td class="py-1 border-b text-xs lg:text-md text-center border-r"><span><input type="checkbox" v-model="plan.ls_check" @change="validateLSCheck(plan)"></span></td>
                                              <!-- <td class="td"><input v-model="plan.weight" type="text" @keypress="$h.preventInvalidInput" class="input"
                                                  @change="onPlanValueChange(plan, 'weight')" /></td> -->
                                              <td class="td"><input v-model="plan.polish_weight" type="text" @keypress="$h.preventInvalidInput" class="input-50px"
                                                  @change="onPlanValueChange(plan, 'polish_weight')" /></td>

                                              <td class="td"><select v-model="plan.shape" class="select"  :title="getShapeName(plan.shape)"  @change="onPlanValueChange(plan, 'shape')">
                                                  <option v-for="(s, i) in diamond.shapes" :key="i" :value="s.id">{{ s.shape_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.color" class="select-60px"  @change="onPlanValueChange(plan, 'color')">
                                                  <option v-for="(c, i) in diamond.colors" :key="i" :value="c.id">{{ c.color_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.purity" class="select-60px"  @change="onPlanValueChange(plan, 'purity')">
                                                  <option v-for="(p, i) in diamond.purities" :key="i" :value="p.id">{{ p.purity_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.cut" class="select-60px">
                                                  <option v-for="(c, i) in diamond.cuts" :key="i" :value="c.id">{{ c.cut_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.polish" class="select-60px">
                                                  <option v-for="(p, i) in diamond.polish" :key="i" :value="p.id">{{ p.polish_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.symmetry" class="select-60px">
                                                  <option v-for="(s, i) in diamond.symmetry" :key="i" :value="s.id">{{ s.symmetry_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.fluerocent" class="select-60px">
                                                  <option v-for="(s, i) in diamond.fluerocents" :key="i" :value="s.id">{{ s.fluerocent_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.tension" class="select-60px">
                                                  <option v-for="(s, i) in diamond.tensions" :key="i" :value="s.id">{{ s.tension_name }}</option>
                                                </select></td>

                                              <td class="td"><select v-model="plan.ratio" class="select-60px">
                                                  <option v-for="(r, i) in diamond.ratios" :key="i" :value="r.id">{{ r.ratio_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.tabl" class="select-60px">
                                                  <option v-for="(t, i) in diamond.tabls" :key="i" :value="t.id">{{ t.tabl_name }}</option>
                                                </select></td>
                                              <td class="td"><select v-model="plan.height" class="select-60px">
                                                  <option v-for="(h, i) in diamond.heights" :key="i" :value="h.id">{{ h.height_name }}</option>
                                                </select></td>

                                              <td class="td"><input v-model="plan.r_rate" disabled class="input-80px bg-gray-100" /></td>
                                              <td class="td"><input v-model="plan.discount" class="input-50px"
                                                  @change="onPlanValueChange(plan, 'discount')" /></td>
                                              <td class="td"><input v-model="plan.value" class="input-70px"
                                                  @change="onPlanValueChange(plan, 'value')" /></td>
                                              <td class="td"><input v-model="plan.total_value" disabled class="input-70px bg-gray-100" /></td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                              <div class="w-full flex justify-between py-5">
                                <div>

                                  <button class="btn btn-primary btn-sm py-1" title="Add New Rough" @click="addNewPart">
                                    <PlusIcon class="h-4 w-4" /> Add Plan
                                  </button>
                                </div>
                                <div>

                                  <button type="button" class="btn btn-primary btn-sm" @click="submitReturnRough">
                                      Transfer makeable
                                  </button>
                                </div>

                              </div>

                          </div>

                      </div>
                  </div>
              </div>
              <!-- END: Input -->
          </div>
      </div>
      <BarcodeSingleStone ref="BarcodeSingleStone" />
  </div>
  </template>

  <script>
  /* eslint-disable */
  import {
      defineComponent
  } from 'vue'
  import DarkModeSwitcher from '@/components/dark-mode-switcher/Main.vue'
  import {
      BASE_URL
  } from '@/constants/config.js'
  import axios from 'axios'
  import datetime from 'vuejs-datetimepicker';
  import Tabulator from 'tabulator-tables'
  // import BarcodeGenerator from "@/components/barcode-generator/Main.vue";
   import BarcodeSingleStone from '@/components/barcodes/Main.vue'

  export default defineComponent({
      components: {
          DarkModeSwitcher,
          datetime,
          BarcodeSingleStone
      },
      props: {
          rough_id: {
              type: String,
              default: ""
          }
      },

      data() {
          return {
            scanload: false,
            edit_flag: 1,
            scan_lot_no: "",
            last_pack_id: 1,
            plan_details: [],
            edit_plan_details: [],
            packet_details: [],
            stock_items: [],
            user_details: [],
            diamond: {
                colors: [],
                cuts: [],
                purities: [],
                symmetry: [],
                polish: [],
                fluerocents: [],
                tensions: [],
                stones: [],
                shapes: [],
                lengths: [],
                width: [],
                heights: [],
                ratios: [],
                tabls: [],
            },
          }
      },
      computed: {

      },
      mounted() {
          this.getDiamontData();

          this.user_details = this.$store.state.user.currentUser
      },

      methods: {
        setPrintData(item) {
            // console.log(item.mkb_date);
      this.$refs.BarcodeSingleStone.setPrintData({
        id: item.id,
        pieces: item.pieces,
        owner_value: item.owner_value,
        owner_per_ct: item.owner_per_ct,
        vepari_no: item.vepari_no,
        number: item.number,
        type: item.type,
        stock_type: item.stock_type,
        mk_weight: item.mk_weight,
        cr_weight: item.cr_weight,
        weight: item.weight,
        polish_weight: item.polish_weight,
        barnum: item.barnum,
        shape: item.shape ?? "",
        color: item.color ?? "",
        shape_code: item.shape_code,
        color_code: item.color_code,
        purity: item.purity ?? "",
        cut: item.cut ?? "",
        polish: item.polish ?? "",
        symmetry: item.symmetry ?? "",
        fluerocent: item.fluerocent ?? "",
        tension: item.tension ?? "",
        stone: item.stone ?? "",
        length: item.lengths,
        width: item.width,
        height: item.height,
        date: item.created_at,
        in_date: item.in_date,
        exp_out_date: item.exp_out_date,
        mkb_date: item.mkb_date,
        planner_shortcode: item.planner_shortcode
      })
    },
    setPrintAllData(items) {
      let data = [];
      items.forEach(element => {
        // console.log(element.mkb_date);
        data.push({
          id: element.id,
          owner_value: element.owner_value,
          owner_per_ct: element.owner_per_ct,
          vepari_no: element.vepari_no,
          pieces: element.pieces,
          number: element.number,
          type: element.type,
          stock_type: element.stock_type,
          mk_weight: element.mk_weight,
          cr_weight: element.cr_weight,
          weight: element.weight,
          polish_weight: element.polish_weight,
          barnum: element.barnum,
          shape: (element.shape ?? ""),
          color: (element.color ?? ""),
          shape_code: element.shape_code,
          color_code: element.color_code,
          purity: (element.purity ?? ""),
          cut: (element.cut ?? ""),
          polish: (element.polish ?? ""),
          symmetry: (element.symmetry ?? ""),
          fluerocent: (element.fluerocent ?? ""),
          tension: (element.tension ?? ""),
          stone: (element.stone ?? ""),
          length: element.lengths,
          width: element.width,
          height: element.height,
          date: element.created_at,
          in_date: element.in_date,
          exp_out_date: element.exp_out_date,
          mkb_date: element.mkb_date,
          planner_shortcode: element.planner_shortcode
        })

      });
      this.$refs.BarcodeSingleStone.setPrintAllData(data)
    },
          async scanAndAddPack() {
              let _this = this;
              _this.clearSearch(this.scan_lot_no);
              this.scanload = true;

              //get lot details
              const data = {
                  barcode: this.scan_lot_no,
              };
              let url_post = '';
              if (this.scan_lot_no != '') {
                  url_post = "api/process/get_packet_details_for_recive_ls_makeable"
              } else {
                  url_post = "api/process/get_packet_details_for_recive_ls_makeable"
              }
              let promise = axios({
                  url: url_post,
                  method: "post",
                  data: data,
                  baseURL: BASE_URL,
                  headers: {
                      Authorization: "Bearer " + localStorage.getItem("token"),

                  },
                  config: {
                      headers: {
                          Accept: "application/json"
                      }
                  },
              });
              return promise
              .then((result) => result.data)
              .then((data) => {

                this.packet_details = data.packet_details
                this.plan_details = data.plan_details
                this.plan_details.lengths = data.plan_details.length
                this.stock_items = data.stock_items

                // Get Last Packet ID
                if(this.packet_details.length > 0) {

                  this.last_pack_id = this.packet_details[this.packet_details.length - 1].id
                }

                this.scanload = false;

              })
              .catch((_error) => {
                  this.scanload = false;
                  return [];
              });
          },
          async editMakeable() {
              let _this = this;

              //get lot details
              const data = {
                  packet_id: this.packet_details.id,
              };
              let url_post = "api/edit/get_packet_plan_detail"
              let promise = axios({
                  url: url_post,
                  method: "post",
                  data: data,
                  baseURL: BASE_URL,
                  headers: {
                      Authorization: "Bearer " + localStorage.getItem("token"),

                  },
                  config: {
                      headers: {
                          Accept: "application/json"
                      }
                  },
              });
              return promise
              .then((result) => result.data)
              .then((data) => {
                this.edit_flag = 2;
                this.edit_plan_details = data.items

              })
              .catch((_error) => {
                  return [];
              });
          },
          clearSearch(lot_no) {
              this.edit_plan_details = [];
              this.plan_details = [];
              this.packet_details = [];
              this.stock_items = [];
              this.edit_flag = 1;
              this.scanload = false
          },
          getDiamontData() {
              axios({
                  url: 'api/master/get_all_parameters',
                  method: 'post',
                  baseURL: BASE_URL,
                  headers: {
                      Authorization: 'Bearer ' + localStorage.getItem('token')
                  },
                  config: {
                      headers: {
                          'Accept': 'application/json'
                      }
                  }
              }).then((res) => {
                  this.diamond.colors = res.data.color
                  this.diamond.cuts = res.data.cut
                  this.diamond.purities = res.data.purity
                  this.diamond.polish = res.data.polish
                  this.diamond.shapes = res.data.shape
                  this.diamond.symmetry = res.data.symmetry
                  this.diamond.fluerocents = res.data.fluerocent
                  this.diamond.tensions = res.data.tension
                  this.diamond.stones = res.data.stone
                  this.diamond.lengths = res.data.lengths
                  this.diamond.width = res.data.width
                  this.diamond.heights = res.data.height
                  this.diamond.tabls = res.data.tabl
                  this.diamond.ratios = res.data.ratio
              })
          },
          addNewPart() {
            if(this.edit_flag == 1) {

              this.last_pack_id = this.last_pack_id + 1
              this.plan_details.push({
                  id: this.last_pack_id,
                  packet_id: "",
                  weight: '',
                  polish_weight: '',
                  color: '',
                  cut: '',
                  purity: '',
                  polish: '',
                  shape: '',
                  symmetry: '',
                  fluerocent: '',
                  tension: '',
                  stone: this.packet_details.stone,
                  height: '',
                  lengths: '',
                  width: '',
                  ratio: '',
                  tabl: '',
                  r_rate: '',
                  value: '',
                  total_value: '',
                  discount: '',
                  is_makeable: true,
                  ls_check: false,
              })
            } else {
              this.last_pack_id = this.last_pack_id + 1
              this.edit_plan_details.push({
                  id: this.last_pack_id,
                  packet_id: "",
                  weight: '',
                  polish_weight: '',
                  color: '',
                  cut: '',
                  purity: '',
                  polish: '',
                  shape: '',
                  symmetry: '',
                  fluerocent: '',
                  tension: '',
                  stone: this.packet_details.stone,
                  height: '',
                  lengths: '',
                  width: '',
                  ratio: '',
                  tabl: '',
                  r_rate: '',
                  value: '',
                  total_value: '',
                  discount: '',
                  is_makeable: true,
                  ls_check: false,
              })

            }
          },
          loadPlanningValues(plan) {
              if (plan.polish_weight != '') {
                  if (parseFloat(plan.polish_weight) > parseFloat(this.packet_details.cr_weight)) {
                      plan.polish_weight = ""
                      this.$swal("Warning!", "Polish Must Less then Makeable Weight!", "warning")

                  }
              }
              if (plan.color != '' && plan.cut != '' && plan.purity != '' && plan.polish != '' && plan.shape != '' && plan.symmetry != '' && plan.fluerocent != '' && plan.height != '' && plan.ratio != '' && plan.tabl != '') {

                  let shape_name = ''
                  var i = this.diamond.shapes.length;
                  while (i--) {
                      if (this.diamond.shapes[i]['id'] == plan.shape) {
                          shape_name = this.diamond.shapes[i]['shape_group']
                      }
                  }
                  let params = {
                      color: plan.color,
                      cut: plan.cut,
                      purity: plan.purity,
                      polish: plan.polish,
                      symmetry: plan.symmetry,
                      fluerocent: plan.fluerocent,
                      tension: plan.tension,
                      lengths: plan.lengths,
                      width: plan.width,
                      height: plan.height,
                      ratio: plan.ratio,
                      tabl: plan.tabl,
                      girdleper: plan.girdleper,
                      shape: plan.shape,
                      shape_group: shape_name,
                      polish_weight: plan.polish_weight,
                      stone: plan.stone,
                  }
                  axios({
                      url: 'api/plan/get_plan_values',
                      method: 'post',
                      baseURL: BASE_URL,
                      data: params,
                      headers: {
                          Authorization: 'Bearer ' + localStorage.getItem('token')
                      },
                      config: {
                          headers: {
                              'Accept': 'application/json'
                          }
                      }
                  }).then((res) => {
                      let rap_value = res.data.rape_value
                      let back = res.data.back

                      plan.r_rate = parseFloat(rap_value * plan.polish_weight).toFixed(2)
                      plan.discount = back
                      plan.value = plan.r_rate - (plan.r_rate * back / 100)
                  })
              }

          },
          submitReturnRough() {
              let submit = true

              // if(this.menual_total.is_all_chacked == false && !(this.menual_total.rough_weight > 0)) {

              //   this.$swal("Warning!", "Rough weight can not be 0 or Empty !", "warning");
              //   submit = false;
              //   return;
              // }

              let checked = false

              if(this.edit_flag == 1) {

                this.plan_details.forEach(plan => {
                    if (plan.ls_check == true) {
                      checked = true
                      if (!(plan.polish_weight) || !(plan.color) || !(plan.cut) || !(plan.purity) || !(plan.polish) || !(plan.shape) || !(plan.symmetry) || !(plan.fluerocent) || !(plan.height) || !(plan.ratio) || !(plan.tabl)) {
                            this.$swal("Warning!", "Planning Fields are Empty !", "warning")
                            submit = false
                        }
                    }
                });
              } else {

                this.edit_plan_details.forEach(plan => {
                    if (plan.ls_check == true) {
                      checked = true
                      if (!(plan.polish_weight) || !(plan.color) || !(plan.cut) || !(plan.purity) || !(plan.polish) || !(plan.shape) || !(plan.symmetry) || !(plan.fluerocent) || !(plan.height) || !(plan.ratio) || !(plan.tabl)) {
                            this.$swal("Warning!", "Planning Fields are Empty !", "warning")
                            submit = false
                        }
                    }
                });
              }
              if (submit == true && checked == true) {

                  this.$swal({
                      title: "Are you sure?",
                      text: "You are You Want To Update Makeable!",
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Submit",
                      showLoaderOnConfirm: true,
                      cancelButtonText: "Cancel",

                      allowOutsideClick: () => !$Swal.isLoading()
                  }).then(result => {
                      if (result.isConfirmed) {

                        if(this.edit_flag == 1) {

                          let params = {
                              plan_details: this.plan_details,
                              packet_id: this.packet_details.id,
                              ip: localStorage.getItem('sk_key')
                          }

                          let api_url = 'api/process/receive_makeable';
                          let promise = axios({
                              url: api_url,
                              method: "post",
                              data: params,
                              baseURL: BASE_URL,
                              headers: {
                                  Authorization: "Bearer " + localStorage.getItem("token"),

                              },
                              config: {
                                  headers: {
                                      Accept: "application/json"
                                  }
                              },
                          });
                          return promise
                            .then((result) => result.data)
                            .then((data) => {
                                if (data.status == 'success') {
                                    this.$swal("Success!", "Packet Plan Updated.", "success");
                                    this.scanAndAddPack()
                                }else if (data.status == 'error') {
                                    this.$swal("Warning!", data.message, "warning");
                                } else {
                                    this.$swal("Warning!", "Somthing Wants Wrong!", "warning");
                                }
                            })
                        } else {
                          let params = {
                              plan_details: this.edit_plan_details,
                              packet_id: this.packet_details.id,
                              type: "create",
                              ip: localStorage.getItem('sk_key'),
                              action_type: 1
                          }

                          let api_url = 'api/edit/edit_makeable_transfer';
                          let promise = axios({
                              url: api_url,
                              method: "post",
                              data: params,
                              baseURL: BASE_URL,
                              headers: {
                                  Authorization: "Bearer " + localStorage.getItem("token"),

                              },
                              config: {
                                  headers: {
                                      Accept: "application/json"
                                  }
                              },
                          });
                          return promise
                            .then((result) => result.data)
                            .then((data) => {
                                if (data.status == 'success') {
                                    this.$swal("Success!", "Packet Plan Updated.", "success");
                                    this.scanAndAddPack()
                                } else {

                                  if(data.type == "warning") {
                                    this.submitReturnRoughConfirm(data.message);
                                  } else {
                                    this.$swal("Warning!", "Somthing Wants Wrong!", "warning");
                                  }

                                }
                            })

                        }
                      }
                  });

              }
          },
          submitReturnRoughConfirm(message) {


              this.$swal({
                  title: "Are you sure?",
                  text: "You are You Want To Update Makeable!",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Submit",
                  showLoaderOnConfirm: true,
                  cancelButtonText: "Cancel",

                  allowOutsideClick: () => !$Swal.isLoading()
              }).then(result => {
                  if (result.isConfirmed) {


                    let params = {
                        plan_details: this.edit_plan_details,
                        packet_id: this.packet_details.id,
                        type: "confirm",
                        ip: localStorage.getItem('sk_key'),
                        action_type: 1
                    }

                    let api_url = 'api/edit/edit_makeable_transfer';
                    let promise = axios({
                        url: api_url,
                        method: "post",
                        data: params,
                        baseURL: BASE_URL,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token"),

                        },
                        config: {
                            headers: {
                                Accept: "application/json"
                            }
                        },
                    });
                    return promise
                      .then((result) => result.data)
                      .then((data) => {
                          if (data.status == 'success') {
                              this.$swal("Success!", "Packet Plan Updated.", "success");
                              this.scanAndAddPack()
                          } else {

                            if(data.type == "warning") {

                            } else {
                              this.$swal("Warning!", "Somthing Wants Wrong!", "warning");
                            }

                          }
                      })
                  }
              });
          },
          resetMakeable() {
            this.$swal({
                      title: "Are you sure?",
                      text: "You are You Want To Update Makeable!",
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Submit",
                      showLoaderOnConfirm: true,
                      cancelButtonText: "Cancel",

                      allowOutsideClick: () => !$Swal.isLoading()
                  }).then(result => {
                      if (result.isConfirmed) {

                          let params = {
                            action_type: 2,
                            type: "create",
                            packet_id: this.packet_details.id,
                            ip: localStorage.getItem('sk_key')
                          }

                          let api_url = 'api/edit/edit_makeable_transfer';
                          let promise = axios({
                              url: api_url,
                              method: "post",
                              data: params,
                              baseURL: BASE_URL,
                              headers: {
                                  Authorization: "Bearer " + localStorage.getItem("token"),

                              },
                              config: {
                                  headers: {
                                      Accept: "application/json"
                                  }
                              },
                          });
                          return promise
                              .then((result) => result.data)
                              .then((data) => {
                                  if (data.status == 'success') {
                                      this.$swal("Success!", "Packet Plan Updated.", "success");
                                      this.scanAndAddPack()
                                  } else {

                                    if(data.type == "warning") {
                                      this.resetMakeableConfirm(data.message)
                                    } else {
                                      this.$swal("Warning!", data.message, "warning");
                                    }

                                  }
                              })
                      }
                  });
          },
          resetMakeableConfirm(message) {
            this.$swal({
                      title: "Are you sure?",
                      text: message,
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Submit",
                      showLoaderOnConfirm: true,
                      cancelButtonText: "Cancel",

                      allowOutsideClick: () => !$Swal.isLoading()
                  }).then(result => {
                      if (result.isConfirmed) {

                          let params = {
                            action_type: 2,
                            type: "confirm",
                            ip: localStorage.getItem('sk_key'),
                            packet_id: this.packet_details.id,
                          }

                          let api_url = 'api/process/edit_makeable_transfer';
                          let promise = axios({
                              url: api_url,
                              method: "post",
                              data: params,
                              baseURL: BASE_URL,
                              headers: {
                                  Authorization: "Bearer " + localStorage.getItem("token"),

                              },
                              config: {
                                  headers: {
                                      Accept: "application/json"
                                  }
                              },
                          });
                          return promise
                              .then((result) => result.data)
                              .then((data) => {
                                  if (data.status == 'success') {
                                      this.$swal("Success!", "Packet Plan Updated.", "success");
                                      this.scanAndAddPack()
                                  } else {

                                    if(data.type == "warning") {

                                    } else {
                                      this.$swal("Warning!", data.message, "warning");
                                    }

                                  }
                              })
                      }
                  });
          },
          reset_ls_data() {
            this.$swal({
                      title: "Are you sure?",
                      text: "You are You Want To Reset LS!",
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Submit",
                      showLoaderOnConfirm: true,
                      cancelButtonText: "Cancel",

                      allowOutsideClick: () => !$Swal.isLoading()
                  }).then(result => {
                      if (result.isConfirmed) {

                          let params = {
                              packet_id: window.btoa(this.packet_details.id),
                              ip: localStorage.getItem('sk_key')
                          }

                          let api_url = 'api/process/cancel_plan_done'

                          let promise = axios({
                              url: api_url,
                              method: "post",
                              data: params,
                              baseURL: BASE_URL,
                              headers: {
                                  Authorization: "Bearer " + localStorage.getItem("token"),

                              },
                              config: {
                                  headers: {
                                      Accept: "application/json"
                                  }
                              },
                          });
                          return promise
                              .then((result) => result.data)
                              .then((data) => {
                                  if (data.status == 'success') {
                                      this.$swal("Success!", data.message, "success");
                                      this.scanAndAddPack()
                                  } else {

                                      this.$swal("Warning!", data.message, "warning");
                                  }
                              }).catch((error) => {
                                this.$swal("Warning!", "Something went wrong.", "warning");
                              })
                      }
                  });
          },
          clearSearch(lot_no) {
            this.scan_lot_no = lot_no;
            this.plan_details = [];
            this.edit_plan_details = [];
            this.packet_details = [];
            this.stock_items = [];
            this.last_pack_id = 1
            this.edit_flag = 1
          },
          validateLSCheck(item) {

            if(this.edit_flag == 1) {

              this.plan_details.forEach(element => {

                if(element.id != item.id) {
                  element.ls_check = false
                }
              });
            } else {

              this.edit_plan_details.forEach(element => {

                if(element.id != item.id) {
                  element.ls_check = false
                }
              });
            }
          },
          async onPlanValueChange(plan, type) {
            const toNum = (val) => parseFloat(val) || 0;

            const calculateValueFromDiscount = () => {
              const rate = toNum(plan.r_rate);
              const discount = toNum(plan.discount);
              plan.value = (rate + (rate * discount) / 100).toFixed(2);
            };

            const calculateDiscountFromValue = () => {
              const rate = toNum(plan.r_rate);
              const value = toNum(plan.value);
              plan.discount = rate ? ((value - rate) * 100) / rate : 0;
            };

            const checkPackLimit = async (field) => {

              if (
                toNum(plan[field]) >
                toNum(this.packet_details.cr_weight)
              ) {
                plan[field] = "";
                return false;
              }
              return true;
            };

            const updateRepoRateAndValue = async () => {
              const repo = await this.getRepoValue(plan);
              plan.r_rate = repo?.r_rate || 0;
              calculateValueFromDiscount();
            };

            switch (type) {
              case "weight":
                if (plan.weight !== "") {
                  await checkPackLimit("weight");
                }
                break;

              case "polish_weight":
                if (plan.polish_weight !== "") {
                  const isValid = await checkPackLimit("polish_weight");

                  if (isValid) {
                    await updateRepoRateAndValue();
                  }
                } else {
                  plan.r_rate = "";
                  plan.value = "";
                }
                break;

              case "discount":
                calculateValueFromDiscount();
                break;

              case "value":
                calculateDiscountFromValue();
                break;


              case "shape":
              case "color":
              case "purity":
                await updateRepoRateAndValue();
                break;
            }

            plan.total_value = (toNum(plan.value) * toNum(plan.polish_weight)).toFixed(2);

          },
          async getRepoValue(plan) {
          try {
            // Required fields check
            if (
              !plan.shape ||
              !plan.color ||
              !plan.purity ||
              !plan.polish_weight
            ) {
              return { r_rate: 0 };
            }

            // Get shape group
            const shapeObj = this.diamond.shapes.find(
              (s) => s.id == plan.shape
            );

            const params = {
              color: plan.color,
              cut: plan.cut,
              purity: plan.purity,
              polish: plan.polish,
              symmetry: plan.symmetry,
              fluerocent: plan.fluerocent,
              tension: plan.tension,
              height: plan.height,
              ratio: plan.ratio,
              tabl: plan.tabl,
              shape: plan.shape,
              shape_group: shapeObj?.shape_group || "",
              polish_weight: plan.polish_weight,
              stone: plan.stone,
            };

            const res = await axios({
              url: "api/plan/get_plan_values",
              method: "post",
              baseURL: BASE_URL,
              data: params,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                Accept: "application/json",
              },
            });

            return {
              r_rate: res?.data?.rape_value || 0,
            };
          } catch (error) {
            console.error("Repo value API error:", error);
            return { r_rate: 0 };
          }
        },
        getShapeName(id) {
    return this.diamond.shapes.find(s => s.id === id)?.shape_name || '';
  }
      },

  })
  </script>


<style scoped>
.th {
  border: 1px solid #d1d5db;
  padding: 6px 0px;
  font-size: 12px;
  font-weight: 600;
  background: #f1f5f9;
  white-space: nowrap;
}

.th-group {
  border: 1px solid #d1d5db;
  padding: 6px 0px;
  font-size: 12px;
  font-weight: 700;
  background: #e2e8f0;
  text-align: center;
}

.td {
  border: 1px solid #d1d5db;
  padding: 4px;
  white-space: nowrap;
}

.input {
  width: 100px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-sm {
  width: 70px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-80px {
  width: 80px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-70px {
  width: 70px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-60px {
  width: 60px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}
.input-50px {
  width: 50px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}

.select {
  width: 90px;              /* FIXED WIDTH */
  max-width: 90px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-80px {
  width: 80px;              /* FIXED WIDTH */
  max-width: 80px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-70px {
  width: 70px;              /* FIXED WIDTH */
  max-width: 70px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-60px {
  width: 60px;              /* FIXED WIDTH */
  max-width: 60px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-50px {
  width: 50px;              /* FIXED WIDTH */
  max-width: 50px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
